import { ActivityType, BusinessScopeType } from '../../api/interfaces/expenses.interface';

export type ExpenseSourceCode = 'user' | 'efatura' | 'efatura-mock';
export const EXPENSE_SOURCE_CODES = [
  'user',
  'efatura',
  'efatura-mock',
] as const satisfies ReadonlyArray<ExpenseSourceCode>;

export type ExpenseStatusCode = 'registered' | 'cancelled';
export const EXPENSE_STATUS_CODES = ['registered', 'cancelled'] as const satisfies ReadonlyArray<ExpenseStatusCode>;

export const CATEGORY_CODES = [
  'C01',
  'C02',
  'C03',
  'C04',
  'C05',
  'C06',
  'C07',
  'C08',
  'C09',
  'C10',
  'C11',
  'C12',
  'C99',
  null,
] as const satisfies ReadonlyArray<ActivityType | null>;

export const KNOWN_ACTIVITY_TYPES = CATEGORY_CODES.filter((code): code is ActivityType => code !== null);

export const BUSINESS_SCOPE_VALUES = [0, 1, 2] as const satisfies ReadonlyArray<BusinessScopeType>;

export type ExpensesSortKey = 'emittedAt' | 'documentNumber' | 'totalValue' | 'taxValue';
export const EXPENSES_SORT_KEYS = [
  'emittedAt',
  'documentNumber',
  'totalValue',
  'taxValue',
] as const satisfies ReadonlyArray<ExpensesSortKey>;

export type ExpensesSortOrder = 'asc' | 'desc';
export const EXPENSES_SORT_ORDERS = ['asc', 'desc'] as const satisfies ReadonlyArray<ExpensesSortOrder>;

export interface ExpenseParty {
  id: number;
  name: string | null;
  identifier: string | null;
}

export interface ExpenseListItem {
  id: number;
  documentNumber: string | null;
  emittedAt: string;
  totalValue: number;
  taxValue: number;
  hasBusinessScope: BusinessScopeType | null;
  activityType: ActivityType | null;
  source: ExpenseSourceCode;
  status: ExpenseStatusCode;
  party: ExpenseParty | null;
}

export interface ExpensesListMeta {
  page: number;
  limit: number;
  totalItems: number;
  totalPages: number;
}

export interface ExpensesListResponse {
  items: ExpenseListItem[];
  meta: ExpensesListMeta;
}

export interface ExpenseCategorySummaryItem {
  code: ActivityType | null;
  totalValue: number;
  documents: number;
}

export interface ExpensesCategorySummaryResponse {
  year: number;
  totals: ExpenseCategorySummaryItem[];
}

export interface ExpensesListQuery {
  page?: number;
  limit?: number;
  documentNumber?: string;
  entityName?: string;
  entityIdentifier?: string;
  emittedFrom?: Date | string;
  emittedTo?: Date | string;
  category?: ActivityType;
  source?: ExpenseSourceCode;
  hasBusinessScope?: BusinessScopeType;
  search?: string;
  sortBy?: ExpensesSortKey;
  sortOrder?: ExpensesSortOrder;
}

export interface ExpensesCategorySummaryQuery {
  year?: number;
}

export type ExpenseListItemResponse = ExpenseListItem;
export type ExpensesListResponseDto = ExpensesListResponse;
export type ExpenseCategorySummaryItemResponse = ExpenseCategorySummaryItem;
export type ExpensesCategorySummaryResponseDto = ExpensesCategorySummaryResponse;
export type ExpensesQueryParams = ExpensesListQuery;
